import React from 'react';
import { MutationStatus } from 'react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { UploadedFile } from 'web-library/models/UploadedFile';
import { usePostWithdrwalUploadDocuments } from '../../../api/candidate/exam/@candidate/queries-services/queries';
import { CustomMutateReturn } from '../../../hooks/query';
import { WithdrawalPostUploadDocumentsRequest } from '../../../api/candidate/exam/model';
import { GenericErrorResponse } from '../../../api-refactored/typings';

interface IPostPresignLinks {
  files: UploadedFile[];
  setFiles: React.Dispatch<React.SetStateAction<UploadedFile[]>>;
  setShouldSubmit: React.Dispatch<React.SetStateAction<boolean>>;
  setApiButtonStatus: React.Dispatch<React.SetStateAction<MutationStatus>>;
  setErrorMsg: React.Dispatch<React.SetStateAction<string>>;
}
const usePostPresignLinks = ({
  files,
  setFiles,
  setShouldSubmit,
  setApiButtonStatus,
  setErrorMsg,
}: IPostPresignLinks): CustomMutateReturn<
  AxiosResponse<WithdrawalPostUploadDocumentsRequest>,
  AxiosError<GenericErrorResponse>,
  WithdrawalPostUploadDocumentsRequest,
  unknown
> =>
  usePostWithdrwalUploadDocuments(
    ({ data }) => {
      const newFiles = [];
      for (let i = 0; i < files.length; i += 1) {
        const pendingFile = files[i];
        const fileData = data[i];
        pendingFile.presignedUrl = fileData.presignedUrl;
        pendingFile.key = fileData.key;
        newFiles.push(pendingFile);
      }
      setFiles(newFiles);

      setShouldSubmit(true);
    },
    (err) => {
      setErrorMsg(err?.response?.data.message);
      setApiButtonStatus('error');
      setFiles(files.map((file) => ({ ...file, pending: false })));
    }
  );

export default usePostPresignLinks;
